<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import { cloneDeep } from "lodash";
import { Carousel, Slide } from "vue-carousel";
import Multiselect from "vue-multiselect";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import ItemList from "@/components/modals/item-list.vue";
import ItemCategory from "@/components/modals/item-category.vue";
import Unit from "@/components/modals/unit.vue";

const greaterThanZero = (value) => value.replace(/,/g, "") > 0;
export default {
    page: {
        title: "Purchase Request Migration",
    },
    components: {
        Layout,
        PageHeader,
        Carousel,
        Slide,
        Multiselect,
        MaskedInput,
        ItemList,
        ItemCategory,
        Unit
    },
    data() {
        return {
            title: "Purchase Request Migration",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Purchase Request Migration",
                    active: true,
                },
            ],
            pageOptions: [10, 25, 50, 100],
            modalTitle: "",
            prData: [],
            pr: {
                id: 0,
                prNumber: null,
                description: null,
                deliveryUnitId: "",
                deliveryUnit: {},
                cycle: 0,
            },
            filterPR: "",
            perPagePR: 10,
            currentPagePR: 1,
            prLoading: false,
            dus: [],
            prIndex: -1,
            prDetails: [],
            slideNum: 1,
            selectedPR: "",
            selectedPRId: 0,
            filterItem: "",
            perPageItem: 10,
            item: {
                prId: 0,
                itemName: null,
                description: null,
                unitId: null,
                type: null,
                subType: null,
                itemCategoryId: null,
                fundClusterId: null,
                unitCost: "0",
                migrationPrItemDetails: [],
            },
            isProcurable: true,
            itemLoading: false,
            currentPageItem: 1,
            unit: null,
            itemCategory: null,
            subType: "",
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
            detail: {
                id: 0,
                monthId: 0,
                quantity: "1",
                totalAmt: '0',
            },
            months: [],
            detailIndex: -1,
            itemDetails: [],
            itemDetailFields: [
                {
                    key: "month.monthName",
                    label: "Month",
                    variant: "primary",
                },
                {
                    key: "quantity",
                    label: "Qty",
                    variant: "primary",
                    thStyle: { width: "120px" },
                },
                {
                    label: "Total",
                    key: "total",
                    variant: "primary",
                    thStyle: { width: "200px" },
                },
                {
                    key: "actions",
                    variant: "primary",
                    thStyle: { width: "90px" },
                    thClass: "text-center",
                    tdClass: "text-center",
                },
            ],
            itemIndex: -1,
            fundClusters: [],
        };
    },
    computed: {
        filteredPR() {
            let data = this.prData;
            var total = this.currentPagePR * this.perPagePR;
            if (this.filterPR.trim() != "" && this.filterPR) {
                data = data.filter((item) => {
                    return item.description
                        .toUpperCase()
                        .includes(this.filterPR.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPagePR, total);
            if (this.currentPagePR > 1 && currentData.length == 0) {
                total = (this.currentPagePR - 1) * this.perPagePR;
                currentData = data.slice(total - this.perPagePR, total);
            }
            return currentData;
        },
        rowsPR() {
            if (this.filterPR.trim() != "" && this.filterPR) {
                return this.filteredPR.length;
            } else {
                return this.prData.length;
            }
        },
        filteredResourceItems(){
            let data = this.prDetails;
            var total = this.currentPagePR * this.perPagePR;
            if (this.filterItem.trim() != "" && this.filterItem) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filterItem.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPagePR, total);
            if (this.currentPagePR > 1 && currentData.length == 0) {
                total = (this.currentPagePR - 1) * this.perPagePR;
                currentData = data.slice(total - this.perPagePR, total);
            }
            return currentData;
        },
        rowsResourceItem(){
            if (this.filterItem.trim() != "" && this.filterItem) {
                return this.filteredResourceItems.length;
            } else {
                return this.prDetails.length;
            }
        },
        filteredItemDetails(){
            let data = this.itemDetails
            return data.sort((a, b) => a.monthId - b.monthId)
        },
        quantityTotal() {
            var data = this.itemDetails;
            return data.reduce((pv, cv) => {
                return parseFloat(pv) + parseFloat(cv.quantity);
            }, 0);
        },
        amountTotal() {
            var data = this.itemDetails;
            var sum = data.reduce((pv, cv) => {
                return parseFloat(pv) + parseFloat(cv.totalAmt);
            }, 0);
            return this.formatCurrency(sum);
        },
    },
    validations: {
        pr: {
            prNumber: { required },
            description: { required },
            deliveryUnitId: { required },
        },
        item: {
            itemName: { required },
            description: { required },
            unitId: { required },
            type: { required },
            itemCategoryId: { required },
            fundClusterId: { required },
            unitCost: { required, greaterThanZero },
        },
        subType: {required},
        detail: {
            month: { required },
            quantity: { required },
        },
    },
    created() {
        this.getDUs(this.$store.state.data.selectedCampus.id);
        this.getFundCluster();
        this.getMonths();
        this.changeCycle(this.$store.state.data.cycle)
    },
    methods: {
        getFundCluster() {
            this.$store.dispatch("fundcluster/GetFundCluster").then((res) => {
                this.fundClusters = res.data;
            });
        },
        changeCycle(cycle) {
            this.$store
                .dispatch(
                    "pr/GetMigrationPerCycle",
                    cycle
                )
                .then((res) => {
                    this.prData = res.data;
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong - getting DUs",
                        "error"
                    );
                });
        },
        getMonths(){
            this.$store
            .dispatch("month/GetAllMonths")
            .then((res) => {
                this.months = res.data;
            })
            .catch(() => {
                this.showToast("Something went wrong!", "error");
            });
        },
        changeCampus(id){
            this.getDUs(id);
        },
        getDUs(id) {
            this.$store
                .dispatch(
                    "deliveryunit/GetDeliveryUnitByCampus",
                    id
                )
                .then((res) => {
                    this.dus = res.data;
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong - getting DUs",
                        "error"
                    );
                });
        },
        prReset() {
            this.pr = {
                id: 0,
                prNumber: null,
                description: null,
                deliveryUnitId: "",
                deliveryUnit: {},
                cycle: this.$store.state.data.cycle,
            };
        },
        addNewPR() {
            this.prReset();
            this.modalTitle = "Create New Purchase Request";
            this.$bvModal.show("pr-modal");
        },
        getDU(event) {
            this.pr.deliveryUnitId = event.id;
        },
        onCreatePR() {
            this.submitted = true;
            this.$v.pr.$touch();
            if (this.$v.pr.$invalid) {
                return;
            }
            var data = cloneDeep(this.pr);
            if (this.pr.id > 0) {
                this.$store
                    .dispatch("pr/UpdateCpr", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(
                                res.data.errorMessage,
                                "error"
                            );
                        }
                        this.prData.splice(this.prIndex, 1, res.data);
                        this.$bvModal.hide("pr-modal");
                        this.showToast("Successfully updated", "success");
                    })
                    .catch((err) => {
                        let stringErr = err.toString();
                        this.showToast(
                            "Something went wrong! - updating Annual Procurement Plan",
                            "error"
                        );
                    });
            } else {
                this.$store
                    .dispatch("pr/CreatePrMigration", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(
                                res.data.errorMessage,
                                "error"
                            );
                        }
                        this.prData.push(res.data);
                        this.$bvModal.hide("pr-modal");
                        this.showToast("Successfully created", "success");
                    })
                    .catch((err) => {
                        this.showToast(
                            "Something went wrong! - creating Annual Procurement Plan",
                            "error"
                        );
                    });
            }
            this.submitted = false;
        },
        updateCPR(row) {
            this.pr = cloneDeep(row);
            this.prIndex = this.prData.indexOf(row);
            this.modalTitle = "Update PR";
            this.$bvModal.show("pr-modal");
        },
        deletePR(props) {
            var index = this.prData.indexOf(props);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("pr/DeletePr", props.id)
                        .then((res) => {
                            if (res.status == 204) {
                                this.prData.splice(index, 1);
                                this.showToast(
                                    "Successfully deleted",
                                    "success"
                                );
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        viewPRDetails(row) {
            this.selectedPR = `${row.description}'s Details`;
            this.selectedPRId = row.id;
            this.pr = cloneDeep(row);
            this.selectedPRStat = cloneDeep(row.status);
            this.prIndex = this.prData.indexOf(row);
            this.slideNum = 2;
            this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
            this.getPRDetails(row.id);
        },
        getPRDetails(id) {
            this.prLoading = true;
            this.$store
                .dispatch("migrationpritem/GetPRItemByPR", id)
                .then((res) => {
                    res.data.forEach(item => {
                        item.filterKey = `${item.itemName} ${item.description} ${item.itemCategory.name}`
                    })
                    this.prDetails = res.data;
                    this.prLoading = false;
                })
                .catch((err) => {
                    this.prLoading = false;
                    this.showToast(
                        "Something went wrong! - getting PR Details",
                        "error"
                    );
                });
        },
        returnToFirstPage(){
            this.slideNum = 1;
            this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
        },
        onResetPRItem(){
            this.item = {
                prId: 0,
                itemName: null,
                description: null,
                unitId: "",
                type: 'NON-CSE',
                subType: '',
                itemCategoryId: "",
                unitCost: "0",
                fundClusterId: "",
                migrationPrItemDetails: [],
            },
            this.itemDetails = [];
            this.subType = '';
            this.$v.item.$reset();
        },
        addNewItem() {
            this.onResetPRItem();
            this.modalTitle = "Create PR Item";
            this.$bvModal.show("create-item-modal");
        },
        
        totalResourceItemAmt(){
            let total = 0;
            this.prDetails.forEach(item => {
                total += item.total;
            });
            return total;
        },
        getItems() {
            this.$bvModal.show("item-list-modal");
        },
        dropItem(data) {
            this.item = cloneDeep(data);
            if (data.inDbm) {
                this.item.type = "CSE";
            } else {
                this.item.type = "NON-CSE";
            }
            this.item.cseId = data.id;
            this.item.id = 0;
            this.item.unitCost = this.numberWithCommas(data.unitCost);
            this.unit = data.unit.unitName;
            this.itemCategory = data.itemCategory.name;
            this.subType = data.subType;
            this.calculateTotal();
            this.calculateAll(this.item.unitCost)
        },
        getUnit() {
            this.$refs.unit.getData();
            this.$bvModal.show("unit-modal");
        },
        dropUnit(data) {
            this.unit = data.shortName;
            this.item.unitId = data.id;
        },
        getItemCategory() {
            this.$bvModal.show("item-category-modal");
        },
        dropItemCat(data) {
            this.itemCategory = data.name;
            this.item.itemCategoryId = data.id;
        },
        selectMonth(data) {
            this.detail.monthId = data.id;
            this.calculateTotal();
        },
        calculateTotal() {
            let unitCost = this.item.unitCost ? this.getExactAmt(this.item.unitCost) : 0;
            let quantity = this.detail.quantity ? this.getExactAmt(this.detail.quantity) : 0;
            let totalAmt = parseFloat(unitCost) *
                parseFloat(quantity);
            this.detail.totalAmt = this.numberWithCommas(totalAmt)
        },
        onResetDetail() {
            this.detail = {
                id: 0,
                monthId: 0,
                quantity: "1",
                totalAmt: '0',
            };
            this.$v.detail.$reset();
            this.detailIndex = -1;
        },
        onSubmitResourceItem() {
            this.detailError = false;
            this.submitted = true;
            this.$v.item.$touch();
            if (this.$v.item.$invalid) {
                return;
            }
            if (this.isProcurable) {
                this.$v.subType.$touch();
                if (this.$v.subType.$invalid) {
                    return;
                }
                this.item.subType = cloneDeep(this.subType);
            } else {
                this.item.subType = "";
            }
            if (this.detailChecker == 0) {
                return (this.detailError = true);
            }
            if(this.totalBudget < 0){
                return;
            }
            this.pageLoader(true);
            var data = cloneDeep(this.item);
            data.unitCost = this.getExactAmt(data.unitCost);
            if (this.item.id > 0) {
                this.$store
                    .dispatch("migrationpritem/UpdatePRItem", data)
                    .then((res) => {
                        if (res.data.error) {
                            this.pageLoader(false);
                            return this.showToast(
                                res.data.errorMessage,
                                "error"
                            );
                        }
                        this.prDetails.splice(this.itemIndex, 1, data);
                        this.submitDetails(res.data.id, 1);
                    })
                    .catch((err) => {
                        console.log(err);
                        this.showToast("Something went wrong!", "error");
                        this.submitted = false;
                        this.pageLoader(false);
                    });
            } else {
                data.prId = this.selectedPRId;
                this.$store
                    .dispatch("migrationpritem/CreateSinglePRItem", data)
                    .then((res) => {
                        if (res.data.error) {
                            this.pageLoader(false);
                            return this.showToast(
                                res.data.errorMessage,
                                "error"
                            );
                        }
                        res.data.itemCategory = data.itemCategory;
                        res.data.unit = data.unit;
                        this.prDetails.push(res.data);
                        this.submitDetails(res.data.id, 0);
                    })
                    .catch((e) => {
                        console.log(e)
                        this.showToast("Something went wrong!", "error");
                        this.submitted = false;
                        this.pageLoader(false);
                    });
            }
        },
        onSubmitItemDetail() {
            this.$v.item.$touch();
            if (this.$v.item.$invalid) {
                return;
            }
            this.$v.detail.$touch();
            if (this.$v.detail.$invalid) {
                return;
            }
            if(this.totalBudget < 0){
                return;
            }
            var data = cloneDeep(this.detail);
            data.totalAmt = this.getExactAmt(this.detail.totalAmt)
            data.total = this.formatCurrency(data.totalAmt);
            if (this.detailIndex > -1) {
                this.itemDetails.splice(this.detailIndex, 1, data);
            } else {
                var exist = this.itemDetails.find(
                    (x) => x.month.id == data.month.id
                );
                if (!exist) {
                    this.itemDetails.push(data);
                } else {
                    var index = this.itemDetails.indexOf(exist);
                    var totalAmt =
                        parseFloat(data.totalAmt) +
                        parseFloat(this.itemDetails[index].totalAmt);
                    this.itemDetails[index].totalAmt = totalAmt;
                    var totalQty =
                        parseFloat(data.quantity) +
                        parseFloat(this.itemDetails[index].quantity);
                    this.itemDetails[index].quantity = totalQty;
                    this.itemDetails[index].total = this.formatCurrency(totalAmt);
                }
            }
            this.onResetDetail();
        },
        async submitDetails(id, opt) {
            var sum = 0;
            for await (const item of this.itemDetails) {
                sum += parseFloat(item.totalAmt);
                item.migrationPrItemId = id;
                if (item.id > 0) {
                    this.$store.dispatch(
                        "migrationpritemdetail/UpdatePRItemDetail",
                        item
                    );
                } else {
                    this.$store.dispatch(
                        "migrationpritemdetail/CreateSinglePRItemDetail",
                        item
                    );
                }
            }
            this.$bvModal.hide("create-item-modal");
            if (opt == 1) {
                this.showToast("Successfully updated!", "success");
            } else {
                this.showToast("Successfully created!", "success");
            }
            this.prDetails.find((e) => e.id === id).total = sum;
            this.submitted = false;
            this.pageLoader(false);
        },
        calculateAll($event) {
            let amount = $event ? this.getExactAmt($event) : 0;
            this.onResetDetail();
            this.itemDetails.forEach((item) => {
                item.totalAmt =
                    parseFloat(amount) *
                    parseFloat(item.quantity);
                item.total = this.formatCurrency(item.totalAmt);
            });
        },
        deleteResourceItem(props) {
            var index = this.prDetails.indexOf(props);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("migrationpritem/DeletePRItem", props.id)
                        .then((res) => {
                            if (res.status == 204) {
                                this.prDetails.splice(index, 1);
                                this.showToast(
                                    "Successfully deleted!",
                                    "success"
                                );
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        updateResourceItem(props) {
            this.item = cloneDeep(props);
            this.item.unitCost = this.numberWithCommas(props.unitCost);
            this.subType = props.subType;
            this.itemCategory = props.itemCategory.name;
            this.unit = props.unit.shortName;
            this.itemIndex = this.prDetails.indexOf(props);
            this.modalTitle = "Update PR Item";
            this.$bvModal.show("create-item-modal");
            this.getItemDetails(props.id);
        },
        getItemDetails(id) {
            this.$store
                .dispatch(
                    "migrationpritemdetail/GetPRItemDetailByPRItem",
                    id
                )
                .then((res) => {
                    res.data.forEach((item) => {
                        item.totalAmt =
                            parseFloat(item.quantity) *
                            parseFloat(this.getExactAmt(this.item.unitCost));
                        item.total = this.formatCurrency(item.totalAmt);
                    });
                    this.itemDetails = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        updateItemDetail(row) {
            this.detailCopy = cloneDeep(row.item);
            this.detail = cloneDeep(row.item);
            this.detail.quantity = row.item.quantity.toString();
            this.detail.totalAmt = this.numberWithCommas(row.item.totalAmt);
            this.detailCopy.quantity = row.item.quantity.toString();
            this.detailCopy.totalAmt = this.numberWithCommas(row.item.totalAmt);
            this.detailIndex = this.itemDetails.indexOf(row.item);
        },
        deleteItemDetail(row) {
            var index = this.itemDetails.indexOf(row.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    if (row.item.id > 0) {
                        this.$store
                            .dispatch(
                                "migrationpritemdetail/DeletePRItemDetail",
                                row.item.id
                            )
                            .then((res) => {
                                if (res.data.error) {
                                    return this.showToast(
                                        res.data.errorMessage,
                                        "error"
                                    );
                                }
                                if (res.status == 204) {
                                    this.itemDetails.splice(index, 1);
                                    this.showToast(
                                        "Successfully deleted!",
                                        "success"
                                    );
                                }
                            })
                            .catch((err) => {
                                this.showToast("Cannot be deleted!", "error");
                            });
                    } else {
                        this.itemDetails.splice(index, 1);
                        this.showToast("Successfully deleted!","success");
                    }
                }
            });
        },
    },
};
</script>
<template>
    <Layout @changeCycle="changeCycle" @changeCampus="changeCampus($event.id)">
        <PageHeader :title="title" :items="items" />
        <b-modal
            id="pr-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreatePR"
                class="needs-validation"
                ref="apiForm"
            >
                <b-row>
                    <b-col>
                        <div class="mb-3">
                            <label for="yearList">PR Number</label>
                            <input
                                type="text"
                                placeholder="Input PR Number..."
                                class="form-control"
                                v-model="pr.prNumber"
                                :class="{
                                    'is-invalid':
                                        submitted && $v.pr.prNumber.$error,
                                }"
                            />
                        </div>
                        <div class="mb-3">
                            <label for="description">Description </label>
                            <textarea
                                id="description"
                                rows="3"
                                v-model="pr.description"
                                placeholder="Enter Description..."
                                class="form-control"
                                :class="{
                                    'is-invalid':
                                        submitted && $v.pr.description.$error,
                                }"
                            ></textarea>
                            <div
                                v-if="submitted && $v.pr.description.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.pr.description.required"
                                    >This value is required.</span
                                >
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="description">Delivery Unit </label>
                            <multiselect
                                v-model="pr.deliveryUnit"
                                :options="dus"
                                label="name"
                                id="region"
                                @select="getDU"
                                :class="{
                                    'is-invalid':
                                        submitted &&
                                        $v.pr.deliveryUnitId.$error,
                                }"
                            ></multiselect>
                            <div
                                v-if="submitted && $v.pr.description.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.pr.description.required"
                                    >This value is required.</span
                                >
                            </div>
                        </div>
                        <div>
                            <label for="yearList">Year</label>
                            <input
                                type="text"
                                placeholder="Input Year..."
                                class="form-control"
                                v-model="pr.cycle"
                                disabled
                            />
                        </div>
                    </b-col>
                </b-row>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('pr-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="create-item-modal"
            :title="modalTitle"
            size="lg"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <div class="mb-2">
                <label for="itemName" class="mb-0">Item Name</label>
                <b-input-group>
                    <template #append>
                        <b-button
                            @click="getItems"
                            variant="outline-info"
                            ><i
                                class="mdi mdi-clipboard-text-search-outline"
                            ></i
                        ></b-button>
                        <b-button
                            @click="onResetPRItem"
                            variant="outline-danger"
                            ><i class="bx bx-x"></i
                        ></b-button>
                    </template>
                    <input
                        autocomplete="off"
                        type="text"
                        placeholder="Input/Search Item..."
                        class="form-control"
                        :class="{
                            'is-invalid': $v.item.itemName.$error,
                        }"
                        v-model="item.itemName"
                    />
                </b-input-group>
                <div v-if="$v.item.itemName.$error" class="invalid-feedback">
                    <span v-if="!$v.item.itemName.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <b-row class="mb-2">
                <b-col sm="6">
                    <label for="description" class="mb-0">Description </label>
                    <textarea
                        autocomplete="off"
                        id="name"
                        rows="6"
                        v-model="item.description"
                        placeholder="Enter Description..."
                        class="form-control"
                        :class="{
                            'is-invalid': $v.item.description.$error,
                        }"
                    ></textarea>
                    <div
                        v-if="$v.item.description.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.item.description.required"
                            >This value is required.</span
                        >
                    </div>
                    <div class="mt-2 mb-2">
                        <div class="d-flex align-items-center">
                            <div v-if="isProcurable" class="w-50 me-2">
                                <select
                                    class="form-select form-select-sm"
                                    id="subType"
                                    v-model="subType"
                                    placeholder="Select Sub Type..."
                                    :class="{
                                        'is-invalid':
                                            submitted && $v.subType.$error,
                                    }"
                                >
                                    <option value="">Select Sub-Type</option>
                                    <option value="Goods">Goods</option>
                                    <option value="Services">Services</option>
                                    <option value="Consultancy">Consultancy</option>
                                    <option value="Infrastructure">Infrastructure</option>
                                </select>
                                <div
                                    v-if="submitted && $v.subType.$error"
                                    class="invalid-feedback"
                                >
                                    <span v-if="!$v.subType.required"
                                        >This value is required.</span
                                    >
                                </div>
                            </div>
                            <div class="w-50">
                                <select
                                    class="form-select form-select-sm"
                                    id="subType"
                                    v-model="item.fundClusterId"
                                    placeholder="Select Sub Type..."
                                    :class="{
                                        'is-invalid':
                                            submitted && $v.item.fundClusterId.$error,
                                    }"
                                >
                                    <option value="">Select Fund Cluster</option>
                                    <option v-for="x in fundClusters" :key="x.id" :value="x.id">{{x.shortName}}</option>
                                </select>
                                <div
                                    v-if="submitted && $v.item.fundClusterId.$error"
                                    class="invalid-feedback"
                                >
                                    <span v-if="!$v.item.fundClusterId.required"
                                        >This value is required.</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col sm="6">
                    <b-row class="mb-2">
                        <b-col sm="6">
                            <label for="name" class="mb-0">Type </label>
                            <input
                                autocomplete="off"
                                id="type"
                                type="text"
                                v-model="item.type"
                                placeholder="Enter Type..."
                                class="form-control"
                                :class="{
                                    'is-invalid': $v.item.type.$error,
                                }"
                                disabled
                            />
                            <div
                                v-if="$v.item.type.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.item.type.required"
                                    >This value is required.</span
                                >
                            </div>
                        </b-col>
                        <b-col sm="6">
                            <label for="unitId" class="mb-0">Unit </label>
                            <b-input-group>
                                <template #append>
                                    <b-button
                                        @click="getUnit"
                                        variant="outline-info"
                                        ><i
                                            class="
                                                mdi
                                                mdi-clipboard-text-search-outline
                                            "
                                        ></i
                                    ></b-button>
                                </template>
                                <input
                                    autocomplete="off"
                                    type="text"
                                    disabled
                                    placeholder="Search Unit..."
                                    class="form-control"
                                    :class="{
                                        'is-invalid': $v.item.unitId.$error,
                                    }"
                                    v-model="unit"
                                />
                            </b-input-group>
                            <div
                                v-if="$v.item.unitId.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.item.unitId.required"
                                    >This value is required.</span
                                >
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col sm="12">
                            <label for="itemCategory" class="mb-0"
                                >Item Category
                            </label>
                            <b-input-group>
                                <template #append>
                                    <b-button
                                        @click="getItemCategory"
                                        variant="outline-info"
                                        ><i
                                            class="
                                                mdi
                                                mdi-clipboard-text-search-outline
                                            "
                                        ></i
                                    ></b-button>
                                </template>
                                <input
                                    autocomplete="off"
                                    type="text"
                                    disabled
                                    placeholder="Search Item Category..."
                                    class="form-control"
                                    :class="{
                                        'is-invalid':
                                            $v.item.itemCategoryId.$error,
                                    }"
                                    v-model="itemCategory"
                                />
                            </b-input-group>
                            <div
                                v-if="$v.item.itemCategoryId.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.item.itemCategoryId.required"
                                    >This value is required.</span
                                >
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <label for="unitCost" class="mb-0">Unit Cost</label>
                            <masked-input
                                autocomplete="off"
                                id="unitCost"
                                type="text"
                                v-model="item.unitCost"
                                class="form-control text-right"
                                :class="{
                                    'is-invalid': $v.item.unitCost.$error,
                                }"
                                @input="calculateAll($event)"
                                :mask="currencyMask"
                            ></masked-input>
                            <div
                                v-if="$v.item.unitCost.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.item.unitCost.required"
                                    >This value is required.</span
                                >
                                <span v-if="!$v.item.unitCost.greaterThanZero"
                                    >This value must be greater than zero.</span
                                >
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <div
                class="p-2 border border-primary"
            >
                <form
                    @submit.prevent="onSubmitItemDetail"
                    class="needs-validation"
                    ref="fcForm"
                >
                    <b-row>
                        <b-col sm="4">
                            <label for="monthId" class="mb-0">Month </label>
                            <multiselect
                                v-model="detail.month"
                                :options="months"
                                label="monthName"
                                @select="selectMonth"
                                track-by="id"
                                value="id"
                                deselect-label=""
                                select-label=""
                                :allow-empty="false"
                                :class="{
                                    'is-invalid': $v.detail.month.$error,
                                }"
                            />
                            <div
                                v-if="$v.detail.month.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.detail.month.required"
                                    >This value is required.</span
                                >
                            </div>
                        </b-col>
                        <b-col sm="2">
                            <label for="qty" class="mb-0">Qty </label>
                            <masked-input
                                autocomplete="off"
                                id="qty"
                                type="text"
                                v-model="detail.quantity"
                                class="form-control text-right"
                                :class="{
                                    'is-invalid': $v.detail.quantity.$error,
                                }"
                                @input="calculateTotal()"
                                :mask="currencyMask"
                            ></masked-input>
                            <div
                                v-if="$v.detail.quantity.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.detail.quantity.required"
                                    >This value is required.</span
                                >
                            </div>
                        </b-col>
                        <b-col sm="6">
                            <label for="total" class="mb-0">Total </label>
                            <div class="d-flex align-items-baseline">
                                <div class="w-75 me-2">
                                    <masked-input
                                        autocomplete="off"
                                        id="total"
                                        type="text"
                                        v-model="detail.totalAmt"
                                        disabled
                                        class="form-control text-right"
                                        :mask="currencyMask"
                                    ></masked-input>
                                </div>
                                <div>
                                    <button
                                        type="submit"
                                        class="btn btn-primary me-1"
                                    >
                                        <i class="bx bx-check"></i>
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-light"
                                        @click="onResetDetail"
                                    >
                                        <i class="bx bx-x"></i>
                                    </button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </form>
                <b-row class="mt-2">
                    <b-col sm="12">
                        <b-table
                            striped
                            hover
                            :items="filteredItemDetails"
                            :fields="itemDetailFields"
                            show-empty
                        >
                            <template #empty="scope">
                                <div class="text-center">
                                    {{ scope.emptyText }}
                                </div>
                            </template>
                            <template #cell(actions)="row">
                                <b-dropdown
                                    class="card-drop"
                                    variant="dark"
                                    right
                                    toggle-class="p-0"
                                >
                                    <template v-slot:button-content>
                                        <i
                                            class="mdi mdi-dots-horizontal fs-5"
                                        ></i>
                                    </template>
                                    <b-dropdown-item
                                        @click="updateItemDetail(row)"
                                        variant="dark"
                                        ><i
                                            class="bx bx-edit font-size-18 me-1"
                                        ></i
                                        >Edit</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                        @click="deleteItemDetail(row)"
                                        variant="danger"
                                        ><i
                                            class="
                                                mdi mdi-trash-can
                                                font-size-18
                                                me-1
                                            "
                                        ></i
                                        >Delete</b-dropdown-item
                                    >
                                </b-dropdown>
                            </template>
                            <template #custom-foot>
                                <b-tr>
                                    <b-th>Total</b-th>
                                    <b-th>{{ quantityTotal }}</b-th>
                                    <b-th>{{ amountTotal }}</b-th>
                                    <b-th>
                                    </b-th>
                                </b-tr>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
            </div>
            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-primary"
                    @click="onSubmitResourceItem"
                >
                    Save changes
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('create-item-modal')"
                >
                    Close
                </button>
            </div>
        </b-modal>
        <carousel
            ref="carousel"
            class="events navs-carousel"
            id="timeline-carousel"
            :navigation-enabled="false"
            :pagination-enabled="false"
            :perPage="1"
            :autoplay="false"
            :minSwipeDistance="0"
            :mouseDrag="false"
        >
            <slide>
                <b-row v-if="slideNum == 1">
                    <b-col sm="3">
                        <div class="card">
                            <div class="card-body p-4">
                                <div class="search-box">
                                    <p class="text-muted">Search</p>
                                    <div class="position-relative">
                                        <input
                                            autocomplete="off"
                                            type="text"
                                            class="
                                                form-control
                                                rounded
                                                border-light
                                            "
                                            placeholder="Search PR..."
                                            v-model="filterPR"
                                        />
                                        <i
                                            class="mdi mdi-magnify search-icon"
                                        ></i>
                                    </div>
                                </div>

                                <hr class="my-3" />
                                <button
                                    type="button"
                                    @click="addNewPR"
                                    class="
                                        btn btn-md btn-block btn-primary
                                        d-flex
                                        align-items-center
                                        justify-content-center
                                    "
                                >
                                    <i class="bx bx-plus fs-6"></i>Create New PR
                                </button>
                                <hr class="my-3" />
                            </div>
                        </div>
                    </b-col>
                    <b-col sm="9">
                        <div class="row">
                            <div class="col-lg-12">
                                <div>
                                    <div class="table-responsive">
                                        <table
                                            class="
                                                table
                                                project-list-table
                                                table-nowrap
                                                table-centered
                                                table-borderless
                                                align-middle
                                            "
                                        >
                                            <thead>
                                                <tr>
                                                    <th
                                                        scope="col"
                                                        width="150px"
                                                    >
                                                        PR Number
                                                    </th>
                                                    <th scope="col">
                                                        PR Description
                                                    </th>
                                                    <th scope="col">
                                                        Delivery Unit
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        width="150px"
                                                        class="text-center"
                                                    >
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="prLoading">
                                                    <td colspan="4">
                                                        <div
                                                            class="
                                                                d-flex
                                                                justify-content-center
                                                                align-items-center
                                                            "
                                                        >
                                                            <div
                                                                class="
                                                                    preloader-component
                                                                    me-2
                                                                "
                                                            >
                                                                <div
                                                                    class="
                                                                        status
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            spinner-chase
                                                                            w-20px
                                                                            h-20px
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <strong
                                                                >Loading...</strong
                                                            >
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr
                                                    v-if="
                                                        filteredPR.length ==
                                                            0 && !prLoading
                                                    "
                                                >
                                                    <td
                                                        colspan="4"
                                                        class="
                                                            text-muted
                                                            text-center
                                                        "
                                                    >
                                                        <i
                                                            class="
                                                                dripicons-warning
                                                                me-1
                                                            "
                                                        ></i
                                                        >No data found
                                                    </td>
                                                </tr>
                                                <tr
                                                    v-for="x in filteredPR"
                                                    :key="x.id"
                                                >
                                                    <td>{{ x.prNumber }}</td>
                                                    <td>
                                                        <h5
                                                            class="
                                                                text-truncate
                                                                font-size-14
                                                            "
                                                        >
                                                            <a
                                                                @click="
                                                                    viewPRDetails(
                                                                        x
                                                                    )
                                                                "
                                                                href="javascript: void(0);"
                                                                class="
                                                                    text-dark
                                                                "
                                                                >{{
                                                                    x.description
                                                                }}</a
                                                            >
                                                        </h5>
                                                    </td>
                                                    <td></td>
                                                    <td class="text-center">
                                                        <div
                                                            class="
                                                                d-flex
                                                                justify-content-center
                                                            "
                                                        >
                                                            <i
                                                                title="Edit"
                                                                class="
                                                                    mdi
                                                                    mdi-circle-edit-outline
                                                                    font-size-18
                                                                    text-dark
                                                                    cursor-pointer
                                                                    me-1
                                                                "
                                                                @click="
                                                                    updatePR(x)
                                                                "
                                                            ></i>
                                                            <i
                                                                title="Delete"
                                                                class="
                                                                    mdi
                                                                    mdi-trash-can-outline
                                                                    font-size-18
                                                                    text-danger
                                                                    cursor-pointer
                                                                    me-1
                                                                "
                                                                @click="
                                                                    deletePR(x)
                                                                "
                                                            ></i>
                                                            <i
                                                                @click="
                                                                    viewPRDetails(
                                                                        x
                                                                    )
                                                                "
                                                                title="View APP Details"
                                                                class="
                                                                    mdi
                                                                    mdi-chevron-right
                                                                    font-size-18
                                                                    text-primary
                                                                    cursor-pointer
                                                                "
                                                            ></i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col">
                                <div
                                    id="tickets-table_length"
                                    class="dataTables_length"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        Show&nbsp;
                                        <b-form-select
                                            class="form-select"
                                            v-model="perPagePR"
                                            size="sm"
                                            :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <div class="col">
                                <div
                                    class="
                                        dataTables_paginate
                                        paging_simple_numbers
                                        float-end
                                    "
                                >
                                    <ul
                                        class="
                                            pagination pagination-rounded
                                            mb-0
                                        "
                                    >
                                        <!-- pagination -->
                                        <b-pagination
                                            v-model="currentPagePR"
                                            :total-rows="rowsPR"
                                            :per-page="perPagePR"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </slide>
            <slide>
                <div v-if="slideNum == 2" class="min-h50vh">
                    <div class="row">
                        <b-col sm="6">
                            <div class="d-flex align-items-center">
                                <a
                                    href="javascript:void(0);"
                                    class="me-1"
                                    @click="returnToFirstPage()"
                                    ><i class="bx bx-left-arrow-alt fs-2"></i
                                ></a>
                                <div>
                                    <h4 class="m-0">
                                        {{ selectedPR }}'s Items
                                    </h4>
                                </div>
                            </div>
                        </b-col>
                        <b-col sm="6" class="text-right">
                            <h4 class="text-muted mb-0">
                                <div class="">
                                    Total:
                                    <b class="text-warning">{{
                                        formatCurrency(totalResourceItemAmt())
                                    }}</b>
                                </div>
                            </h4>
                        </b-col>
                    </div>
                    <b-row>
                        <b-col sm="12" class="mt-2">
                            <div class="row">
                                <div class="col-md-6 d-flex">
                                    <div
                                        id="tickets-table_filter"
                                        class="dataTables_filter me-1"
                                    >
                                        <label
                                            class="
                                                d-inline-flex
                                                align-items-center
                                            "
                                        >
                                            <b-form-input
                                                autocomplete="off"
                                                v-model="filterItem"
                                                type="search"
                                                placeholder="Search Items..."
                                                class="form-control"
                                            ></b-form-input>
                                        </label>
                                    </div>
                                    <div
                                        id="tickets-table_length"
                                        class="dataTables_length"
                                    >
                                        <label
                                            class="
                                                d-inline-flex
                                                align-items-center
                                                mb-0
                                            "
                                        >
                                            <b-form-select
                                                class="form-select"
                                                v-model="perPageItem"
                                                size="sm"
                                                :options="pageOptions"
                                            ></b-form-select>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <button
                                        class="
                                            btn btn-info
                                            d-flex
                                            align-items-center
                                            float-end
                                        "
                                        @click="addNewItem"
                                    >
                                        <i class="bx bx-plus"></i> Add New Item
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div>
                                        <div class="table-responsive">
                                            <table
                                                class="
                                                    table
                                                    project-list-table
                                                    table-centered
                                                    table-borderless
                                                    align-middle
                                                "
                                            >
                                                <thead>
                                                    <tr>
                                                        <th scope="col">
                                                            Item Name
                                                        </th>
                                                        <th scope="col">
                                                            Description
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            width="200px"
                                                        >
                                                            Unit Cost
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            width="200px"
                                                        >
                                                            Total
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            width="150px"
                                                            class="text-center"
                                                        >
                                                            Action
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="itemLoading">
                                                        <td colspan="5">
                                                            <div
                                                                class="
                                                                    d-flex
                                                                    justify-content-center
                                                                    align-items-center
                                                                "
                                                            >
                                                                <div
                                                                    class="
                                                                        preloader-component
                                                                        me-2
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            status
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                spinner-chase
                                                                                w-20px
                                                                                h-20px
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <strong
                                                                    >Loading...</strong
                                                                >
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr
                                                        v-if="
                                                            filteredResourceItems.length ==
                                                                0 &&
                                                            !itemLoading
                                                        "
                                                    >
                                                        <td
                                                            colspan="5"
                                                            class="
                                                                text-muted
                                                                text-center
                                                            "
                                                        >
                                                            <i
                                                                class="
                                                                    dripicons-warning
                                                                    me-1
                                                                "
                                                            ></i
                                                            >No data found
                                                        </td>
                                                    </tr>
                                                    <tr
                                                        v-for="x in filteredResourceItems"
                                                        :key="x.id"
                                                    >
                                                        <td
                                                            class="
                                                                border
                                                                border-end-0
                                                            "
                                                        >
                                                            <div>
                                                                {{ x.itemName }}
                                                            </div>
                                                            <div>
                                                                <small
                                                                    ><i>{{
                                                                        x
                                                                            .itemCategory
                                                                            .name
                                                                    }}</i></small
                                                                >
                                                            </div>
                                                        </td>
                                                        <td
                                                            class="
                                                                border
                                                                border-start-0
                                                                border-end-0
                                                            "
                                                        >
                                                            {{ x.description }}
                                                        </td>
                                                        <td
                                                            class="
                                                                border
                                                                border-start-0
                                                                border-end-0
                                                            "
                                                        >
                                                            {{
                                                                formatCurrency(
                                                                    x.unitCost
                                                                )
                                                            }}
                                                        </td>
                                                        <td
                                                            class="
                                                                border
                                                                border-start-0
                                                                border-end-0
                                                            "
                                                        >
                                                            {{
                                                                formatCurrency(
                                                                    x.total
                                                                )
                                                            }}
                                                        </td>
                                                        <td
                                                            class="
                                                                text-center
                                                                border
                                                                border-start-0
                                                            "
                                                        >
                                                            <b-dropdown
                                                                class="
                                                                    card-drop
                                                                "
                                                                menu-class="dropdown-menu-end"
                                                                variant="white"
                                                                toggle-class="p-0"
                                                            >
                                                                <template
                                                                    v-slot:button-content
                                                                >
                                                                    <i
                                                                        class="
                                                                            mdi
                                                                            mdi-dots-horizontal
                                                                            font-size-18
                                                                        "
                                                                    ></i>
                                                                </template>
                                                                <b-dropdown-item
                                                                    @click="
                                                                        viewItemLogs(
                                                                            x
                                                                        )
                                                                    "
                                                                    variant="dark"
                                                                    ><i
                                                                        class="
                                                                            bx
                                                                            bx-menu-alt-right
                                                                            font-size-18
                                                                            me-1
                                                                        "
                                                                    ></i
                                                                    >View
                                                                    Logs</b-dropdown-item
                                                                >
                                                                <b-dropdown-item
                                                                    @click="
                                                                        updateResourceItem(
                                                                            x
                                                                        )
                                                                    "
                                                                    variant="dark"
                                                                    ><i
                                                                        class="
                                                                            bx
                                                                            bx-edit
                                                                            font-size-18
                                                                            me-1
                                                                        "
                                                                    ></i
                                                                    >Edit</b-dropdown-item
                                                                >
                                                                <b-dropdown-item
                                                                    @click="
                                                                        deleteResourceItem(
                                                                            x
                                                                        )
                                                                    "
                                                                    variant="danger"
                                                                    ><i
                                                                        class="
                                                                            mdi
                                                                            mdi-trash-can
                                                                            font-size-18
                                                                            me-1
                                                                        "
                                                                    ></i
                                                                    >Delete</b-dropdown-item
                                                                >
                                                            </b-dropdown>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col mb-3">
                                    <div
                                        class="
                                            dataTables_paginate
                                            paging_simple_numbers
                                            float-end
                                        "
                                    >
                                        <ul
                                            class="
                                                pagination pagination-rounded
                                                mb-0
                                            "
                                        >
                                            <!-- pagination -->
                                            <b-pagination
                                                v-model="currentPageItem"
                                                :total-rows="rowsResourceItem"
                                                :per-page="perPageItem"
                                            ></b-pagination>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </slide>
        </carousel>
        <item-list @dropData="dropItem($event)"></item-list>
        <unit ref="unit" @dropData="dropUnit($event)"></unit>
        <item-category @dropData="dropItemCat($event)"></item-category>
    </Layout>
</template>